import React from 'react'

import { arrayOf, shape, string } from 'prop-types'

function Faq({ faq }) {
  return (
    <section className="datasets-faq">
      <div className="discover-container datasets-faq__wrap">
        <div className="datasets-faq__intro">
          <h2 className="discover-heading cgt-heading-500">{faq.title}</h2>
          <p className="datasets-faq__subtitle cgt-body-lg">{faq.subtitle}</p>
        </div>
        <div className="datasets-faq__list">
          {faq.items.map(item => (
            <details key={item.question} className="datasets-faq__item">
              <summary className="datasets-faq__question">
                <h3 className="datasets-faq__question-text discover-heading cgt-heading-200">{item.question}</h3>
                <span className="datasets-faq__icon" aria-hidden="true">
                  <span className="datasets-faq__icon-line" />
                  <span className="datasets-faq__icon-line datasets-faq__icon-line--vertical" />
                </span>
              </summary>
              <p className="datasets-faq__answer cgt-body-md">{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  )
}

Faq.propTypes = {
  faq: shape({
    title: string.isRequired,
    subtitle: string.isRequired,
    items: arrayOf(shape({ question: string.isRequired, answer: string.isRequired })).isRequired,
  }).isRequired,
}

export default Faq
